import React, { useMemo } from 'react'
import moment from 'moment'
import { isEmpty, isInteger, isString, keys } from 'lodash'
import { useTranslation } from 'react-i18next'
import useDateTimeFormat from 'utils/hooks/useDateTimeFormat'

const formatValue = (value, formatOptions) => {
  if (isInteger(value)) return value
  if (isString(value)) {
    if (
      !value.match(
        /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/g
      )
    ) {
      return value
    }
  }

  return moment(value).isValid()
    ? moment(value).format(
        `${formatOptions.dateFormat.value} ${formatOptions.timeFormat.value}`
      )
    : value
}

const SummaryColumnFramework = ({ value }) => {
  const { t } = useTranslation('Wizard')
  const formatOptions = useDateTimeFormat()

  if (isEmpty(value)) {
    return null
  }

  const formattedValue = useMemo(() => {
    if (isEmpty(value)) return []
    return keys(value)?.map((key) => ({ key, value: value[key] }))
  }, [value])

  const renderSummaryItem = ({ key, value }) => {
    const tKey = `Table.${key}`
    return (
      <div key={key}>
        <span>{t(tKey)}: </span>
        <span>{formatValue(value, formatOptions)}</span>
      </div>
    )
  }

  const renderSummary = () =>
    formattedValue.map((item) => renderSummaryItem(item))

  return <div className='summary-column'>{renderSummary()}</div>
}

export default SummaryColumnFramework
